import MetricBase from "models/metrics/MetricBase";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";
import PerformanceGroup from "../../../../groups/PerformanceGroup";

class MetricCtr extends MetricBase {
    constructor() {
        super({
            field: "metric_ctr",
            defaultVisibility: false,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.tripadvisor.ctr.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.ctr.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.ctr.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricCtr;
